/* eslint-disable import/prefer-default-export */
export const selectSideMenuModalState = state => state.sideMenuModal;
